<nav class="navbar navbar-expand-lg navbar-light bg-light">
    <a class="navbar-brand" (click)="goToHome()"><img src="assets/img/logo.png" style="cursor: pointer"></a>

    <div class="collapse navbar-collapse">
      <ul class="navbar-nav mr-auto">
        <li class="nav-item ml-47">
          <app-cart></app-cart>
        </li>
        <li class="nav-item ml-4">
          <app-language-picker></app-language-picker>
        </li>
      </ul>
    </div>

</nav>